<template>
    <div class="user-roles-modal">
        <CorePageLoader :loading="usersStore.loadingUserRoles" />
        <div class="roles-container">
            <div class="roles-row">
                <div class="role-name-col">{{ $t('§permissions.ui_table_header_role') }}</div>
                <div class="role-col">
                    {{ $t('§permissions.ui_table_header_is_role_assigned') }}
                </div>
            </div>

            <div
                v-for="(isRoleApplied, roleName) in roles"
                :key="roleName"
                class="roles-row"
            >
                <div class="role-name-col">
                    {{ $t('§permissions.role_' + roleName) }}
                </div>
                <div class="role-col">
                    <CoreCheckbox
                        :modelValue="isRoleApplied === 1"
                        @input="toggleRole(roleName)"
                        :name="`role_checkbox_${roleName}`"
                        label=""
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import { useUsersStore } from '@/stores/users'
import CoreTableCellButton from '@/components/core/CoreTableCellButton.vue'
import CoreValueMissing from '@/components/core/CoreValueMissing.vue'
import CorePageLoader from '@/components/core/CorePageLoader.vue'
import CoreCheckbox from '@/components/core/CoreCheckbox.vue'
import Tag from 'primevue/tag'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'

export default {
    name: 'UserRolesModal',

    components: {
        CoreTableCellButton,
        CoreValueMissing,
        CorePageLoader,
        CoreCheckbox,
        Tag,
        Column,
        DataTable,
    },

    data() {
        return {
            modalStore: useModalStore(),
            usersStore: useUsersStore(),
            roles: {},
        }
    },

    computed: {
        userID() {
            return this.modalStore.data.userID
        },
    },

    mounted() {
        this.getUserRoles()
    },

    beforeUnmount() {
        this.usersStore.usersTableRefreshKey += 1
    },

    methods: {
        async getUserRoles() {
            this.roles = await this.usersStore.getUserRoles(this.userID)
        },

        async toggleRole(roleName) {
            this.usersStore.toggleUserRole(this.userID, roleName)
        },
    },
}
</script>

<style>
.user-roles-modal {
    padding: 40px;
}

.roles-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 300px;
    box-sizing: border-box;
}

.roles-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
}

.roles-row:nth-child(even) {
    background-color: var(--color-neutral-300);
}

.role-name-col,
.role-col {
    flex: 1;
    display: flex;
    border: none;
    box-sizing: border-box;
    margin: 0;
    padding: 8px;
}
.role-name-col {
    text-align: left;
    text-transform: capitalize;
    font-weight: bold;
}
.role-col {
    text-align: center;
    justify-content: center;
    align-items: center;
}
</style>
